export default __webpack_public_path__ + "static/media/ll_poster.35a1d6b8.jpg";